/**
 * Represents a billing period.
 */
class BillingPeriod {
  private static readonly OFFSET_MONTHS = 1;
  private readonly start: Date;
  private readonly end: Date;

  constructor(
    start: Date,
    numberOfMonths: number,
    offsetInMonths: number = BillingPeriod.OFFSET_MONTHS
  ) {
    this.start = this.calculateStart(start, offsetInMonths);
    this.end = this.calculateEnd(this.start, numberOfMonths);
  }

  getStart(): Date {
    return this.start;
  }

  getEnd(): Date {
    return this.end;
  }

  private calculateStart(start: Date, offsetInMonths: number): Date {
    start.setMonth(start.getMonth() + offsetInMonths);
    return this.getDateWithFirstDayOfMonth(start);
  }

  private calculateEnd(start: Date, numberOfMonths: number): Date {
    const end = new Date(start);

    end.setMonth(start.getMonth() + numberOfMonths);
    end.setDate(end.getDate() - 1);

    return this.getDateWithLastDayOfMonth(end);
  }

  private getDateWithFirstDayOfMonth(date: Date) {
    return new Date(date.getFullYear(), date.getMonth(), 1);
  }

  private getDateWithLastDayOfMonth(date: Date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
  }
}

export default BillingPeriod;
